// extracted by mini-css-extract-plugin
export default {"modal":"SuccessModal_modal__xReX4","yes-btn":"SuccessModal_yes-btn__r9ymI"};